// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../types';
import { makeEntitySelector } from '../../../../selectors/zoneSelectors';
import ZoneListItem from '../ZoneListItem';
import type { Props } from '../ZoneListItem';

type OwnProps = $ReadOnly<{|
    id: string,
    selected: $PropertyType<Props, 'selected'>,

    onClick: $PropertyType<Props, 'onClick'>,
    onLocateClick: $PropertyType<Props, 'onLocateClick'>,
    onSelect: $PropertyType<Props, 'onSelect'>,
    onDelete: $PropertyType<Props, 'onDelete'>
|}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    return {
        zone: makeEntitySelector(props.id)(state)
    };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(ZoneListItem);